import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById("first-cta");
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-36" data-mp="gp3y9stq2ykv">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-37" data-mp="go1avuvlze9p">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-2 border-white bg-cta px-4 py-4 text-base font-black uppercase tracking-wide text-white shadow-[0_8px_24px_rgba(14,37,87,0.35)] motion-safe:animate-shake focus-visible:outline focus-visible:outline-4 focus-visible:outline-sun" data-id="element-38" data-mp="14dvgpshig2kg">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-39" data-mp="26a5v94kxx9b2" />
            <span className="whitespace-nowrap" data-id="element-40" data-mp="1rdesqmfyzhh8">Get Instant Access — $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}